import { render, staticRenderFns } from "./PgaOfferEvaluationFixedPriceProjectCreate.vue?vue&type=template&id=c4d9672a&"
import script from "./PgaOfferEvaluationFixedPriceProjectCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationFixedPriceProjectCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4d9672a')) {
      api.createRecord('c4d9672a', component.options)
    } else {
      api.reload('c4d9672a', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationFixedPriceProjectCreate.vue?vue&type=template&id=c4d9672a&", function () {
      api.rerender('c4d9672a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/create/sub-components/PgaOfferEvaluationFixedPriceProjectCreate.vue"
export default component.exports